import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import LancamentoViagem from '../lancamentoViagem/lancamentoViagem';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>
			<Route exact path='/' component={LancamentoViagem} />
			<Redirect from='*' to='/' />
		</Switch>
	</div>
);
